"use client";

import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

interface NavSvgIconProps {
  size?: number;
  className?: string;
  play?: boolean;
}

export function MissionIcon({ size = 66, className, play = true }: NavSvgIconProps) {
  const containerRef = useRef<SVGSVGElement | null>(null);
  const arcsRef = useRef<SVGGElement | null>(null);

  useGSAP(
    () => {
      if (!play || !arcsRef.current) return;
      const mm = gsap.matchMedia();
      mm.add("(prefers-reduced-motion: no-preference)", () => {
        gsap.to(arcsRef.current, {
          rotation: "+=360",
          duration: 30,
          repeat: -1,
          ease: "none",
          svgOrigin: "13.08 13.08",
        });
      });
      return () => mm.revert();
    },
    { scope: containerRef, dependencies: [play] }
  );

  return (
    <svg
      ref={containerRef}
      viewBox="0 0 26.16 26.16"
      width={size}
      height={size}
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth="0.3"
      aria-hidden="true"
    >
      <circle cx="13.08" cy="13.08" r="12.93" strokeMiterlimit="10" />
      <g ref={arcsRef} strokeLinecap="round" strokeLinejoin="round">
        <path d="M19.7,19.7c3.66-3.66,3.66-9.59,0-13.24-1.83-1.83-4.23-2.74-6.62-2.74" />
        <path d="M18.44,18.44c2.96-2.96,2.96-7.76,0-10.72-1.48-1.48-3.42-2.22-5.36-2.22" />
        <path d="M17.18,17.18c2.26-2.26,2.26-5.93,0-8.2-1.13-1.13-2.62-1.7-4.1-1.7" />
        <path d="M15.92,15.92c1.57-1.57,1.57-4.11,0-5.68-.78-.78-1.81-1.18-2.84-1.18" />
        <path d="M13.08,13.08l7.88,7.88c4.35-4.35,4.35-11.41,0-15.76-2.18-2.18-5.03-3.27-7.88-3.27" />
      </g>
      <circle cx="13.08" cy="13.08" r="2.23" strokeMiterlimit="10" />
    </svg>
  );
}
